import React, { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFormContext } from "react-hook-form";

import { Loading, Typography } from "ui-library/atoms";
import { ContentBox } from "ui-library/layouts";

import i18n from "core/i18n";

import useDigisign from "../../hooks/useDigisign";
import { SECTION_MARGIN } from "../../constants";
import { VehicleCancellationFormValues } from "../../types";

export const DigiSignOneTimeSigningSection: FC = () => {
    const { t } = i18n.useTranslation();
    const { idObject } = useParams();

    const { getValues } = useFormContext<VehicleCancellationFormValues>();
    const changeId = getValues("changeSheetId");

    const { checkDigisignEligibility, isDigisignEligibilityLoading, digisignEligibilityData } = useDigisign(idObject, changeId);

    useEffect(() => {
        checkDigisignEligibility();
    }, []);

    return (
        <>
            <ContentBox fullWidth textAlign={"center"} mt={SECTION_MARGIN}>
                <Typography variant="h3">{t("change.signature.requestSignatures")}</Typography>
            </ContentBox>

            <Loading loading={isDigisignEligibilityLoading}>
                <ContentBox fullWidth>
                    <Typography>{t("change.signature.digiSign.oneTime.InfoText", { email: digisignEligibilityData.email })}</Typography>
                </ContentBox>
            </Loading>
        </>
    );
};
